// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"e191d023","239":"4f7d3306","455":"ded6807f","977":"04874467"}[chunkId] + ".chunk.js";
};